import React from "react"

import type { MetricRecordData } from "@/types/metrics/contracts"

import { CustomEndReasonConfig } from "../../configuration/components/CustomEndReasonConfig"
import { BinaryMetricRecord } from "../base/BinaryMetricRecord"

export class CustomEndReasonMetricRecord extends BinaryMetricRecord {
  get hasVersionedConfig() {
    return true
  }

  // TODO: Version tracking should use runtime_metadata once structured runtime metadata is implemented.
  // success_end_reasons should move from result to runtime_metadata.
  isMetricOutputCurrentVersion(_metricOutput: {
    result_json?: Record<string, unknown> | null
  }): boolean {
    return true
  }

  getVersionDiff(_metricOutput: {
    result_json?: Record<string, unknown> | null
  }): Array<{ field: string; current: string; previous: string }> {
    return []
  }

  renderEditorMetadata(
    metricRecordData: MetricRecordData,
    onChange: (metric: MetricRecordData) => void,
  ): React.ReactNode {
    return (
      <CustomEndReasonConfig
        metricRecordData={metricRecordData}
        onChange={onChange}
      />
    )
  }

  renderMetricType(): React.ReactNode {
    return "Successful End Reason"
  }
}
